import http from '../../../utils/services/http'
import axios from 'axios'

export const http2 = (function (options) {
  return axios.create(Object.assign({}, options))
})()

export const dashboard = () => {
  return http.get('/api/callcenter/resumeDashboard')
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const list = (limit, page, filtros) => {
  let url = '/api/callcenter/remocoes?page=' + page + '&limit=' + limit + filtros
  console.log(url)
  return http.get(url) // ?XDEBUG_SESSION_START=ps
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const iniciarAtendimento = (data) => {
  return http.post('/api/callcenter/remocoes', data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const solicitarRemocao = (id, data) => {
  return http.post(`/api/callcenter/remocoes/${id}/solicitar`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const getTickets = () => {
  return http.get(`/api/callcenter/remocoes/getTickets`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const getReboques = () => {
  return http.get('/api/reboquista/disponiveis')
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const atualizarTicket = (id, acao) => {
  let url = ''
  switch (acao) {
    case 'aceitar':
      url = `/api/callcenter/remocoes/${id}/reboquista/aceitar`
      break
    case 'recolher':
      url = `/api/callcenter/remocoes/${id}/reboquista/iniciarRecolhimento`
      break
    case 'transportar':
      url = `/api/callcenter/remocoes/${id}/reboquista/iniciarTransporte`
      break
    case 'entregar':
      url = `/api/callcenter/remocoes/${id}/reboquista/entregar`
      break
  }
  return http.post(url, {admin: true})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const defineReboqueAuto = (id) => {
  return http.post(`/api/callcenter/remocoes/${id}/reboquista/aceitar?forceReboquistaAuto=1`, {})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const snapToRoads = (apiKey, pathValues) => {
  return http2.get(`https://roads.googleapis.com/v1/snapToRoads`, {
    params: {
      interpolate: true,
      key: apiKey,
      path: pathValues.join('|')
    }
  })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const getLocations = () => {
  return http.get(`/api/reboquista/lista-localizacao-disponiveis`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const checkRouteStatus = (id) => {
  return http.get(`/api/solicitacao-remocao/rotas/${id}/status`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const defineKm = (id, tipo, km) => {
  return http.post(`/api/callcenter/remocoes/${id}/km/definir`, {tipo: tipo, km: km})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const saveRoute = (id, data) => {
  return http.post(`/api/callcenter/remocoes/${id}/saveRoute`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const getBasicConfiguration = () => {
  return http.get('/api/callcenter/basicData')
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const prerequisitosLista = () => {
  let url = '/api/callcenter/remocoes/dataRequired'
  console.log(url)
  return http.get(url)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const find = id => {
  let url = `/api/callcenter/remocoes/${id}`
  console.log(url)
  return http.get(url)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const getPublicLinkS3 = fileId => {
  return http.get(`/api/callcenter/remocoes/download-foto-solicitacao?file=${fileId}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export default {
  dashboard,
  list,
  iniciarAtendimento,
  solicitarRemocao,
  getTickets,
  defineReboqueAuto,
  getLocations,
  getReboques,
  saveRoute,
  checkRouteStatus,
  getBasicConfiguration,
  prerequisitosLista,
  find,
  getPublicLinkS3
}



// WEBPACK FOOTER //
// ./src/domain/callcenter/services/index.js